<ama-ng-app-store-hierarchy-list
  [items]="(configurationService.selectOgusWithDeploymentsOrDeployedChildren$ | async) ?? []"
  [actorTemplate]="actor"
  [selectedActor]="(configurationService.activeParent$ | async)?.actor"
  (expandEntity)="configurationService.onExpandEntity([$event])"
  (collapseEntity)="configurationService.onCollapseEntity([$event])">
  <ng-template #actor let-item let-depth="depth">
    <input type="checkbox"
      class="form-check-input me-3 my-0 flex-shrink-0 ms-2"
      [id]="'hierarchy-item-checkbox-' + item.actor.actorName"
      [checked]="item.isSelected"
      [class.invisible]="!item.isDeployed && !item.isParentDeployed"
      (dblclick)="$event.stopPropagation()"
      (change)="toggleIsSelected(item); $event.stopPropagation();"
               [disabled]="(item.isParentDeployed && !areConfigurationOverridesEnabled) || !canCreateConfiguration ||
               (deploymentService.isDeploymentAllowedForGivenEntity$(item) | async) === false"
      aria-label="Select"/>
      <button class="reset-button d-flex flex-row flex-grow-1 align-items-center overflow-hidden"
        [attr.aria-expanded]="!item.isCollapsed"
        (click)="selectEntity(item)"
        (dblclick)="toggleIsExpanded(item); $event.stopPropagation()"
        [id]="'hierarchy-item-' + item.actor.actorName">
        @if (depth < 2) {
          <span
            aria-hidden="true"
            class="{{ item.actor.actorType | entityIcon }} me-1">
          </span>
        }

        <label class="text-nowrap text-truncate me-1"
          [ngbTooltip]="item.actor.actorName | removeParentActor: item.parentOrg?.actorName"
                   [class.disabled]="(item.isDeployed && !canCreateConfiguration) ||
                   (item.isParentDeployed && !areConfigurationOverridesEnabled)">
          {{ item.actor.actorName | removeParentActor: item.parentOrg?.actorName }}
        </label>

        @if (areConfigurationOverridesEnabled && item.configurationOverrides?.length > 0) {
          <span aria-hidden="true"
            class="col text-start flex-grow-1 me-1 ms-2 text-truncate text-gray"
            [ngbTooltip]="item.configurationOverrides | configurationsTooltip"
            placement="top auto" container="body"
            [id]="'configuration-override-name-' +item.actor.actorName"
            >
            {{ item.configurationOverrides  | configurationNames }}
          </span>
          <span [id]="'configuration-override-badge-' + item.actor.actorName"
          class="badge rounded-pill bg-neutral-soft me-2">Override</span>
        }

        @if (item.configurations?.length > 0) {
          <span
            aria-hidden="true"
                  class="d-block flex-grow-1 text-nowrap text-truncate text-end df-badge-dot me-1
                         align-items-center ms-2 text-gray"
            [ngbTooltip]="item.configurations | configurationsTooltip"
            [id]="'configuration-name-' + item.actor.actorName">
            {{ item.configurations  | configurationNames }}
          </span>
        }
      </button>
    </ng-template>
  </ama-ng-app-store-hierarchy-list>
